import * as _ from 'lodash'
import {PeriodHierarchyBO} from "./PeriodHierarchyBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_PeriodHierarchyRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Period_Hierarchy} from "../PA.Core/PAdbSchema";


export class PeriodHierarchyBOValidations {


    static async ValidateFields(aBO: PeriodHierarchyBO): Promise<void> {

        let dbContext = new PAdbContext({})


        // Validate Period Hierarchy Name
        if (_.isEmpty(aBO.WB_PeriodHierarchy.cif.WB_PERIOD_HIER_NAME)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyName',
                    type: MessageType.Error,
                    title: "Period Hierarchy Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyName')
        }

        if (_.isEmpty(aBO.WB_PeriodHierarchy.cif.WB_PERIOD_HIER_ID)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyID',
                    type: MessageType.Error,
                    title: "Period Hierarchy ID cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyID')
        }


        // Period Hierarchies are considered duplicates only within the same Master Data Set
        let periodHRows: WB_PeriodHierarchyRow[] = await dbContext.findAll(esWB_Period_Hierarchy,
            {where: {DELETED_IND: {neq: '1'},
                    WB_PERIODH_ID: {neq: aBO.WB_PeriodHierarchy.cif.WB_PERIODH_ID},
                    WB_MDSET_ID: aBO.WB_PeriodHierarchy.cif.WB_MDSET_ID,
                    WB_PERIOD_HIER_ID: aBO.WB_PeriodHierarchy.cif.WB_PERIOD_HIER_ID}})



        if (!_.isEmpty(periodHRows)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "duplicateID", type: MessageType.Error,
                title: 'Existing Period Hierarchy with the same ID: ' +
                    '\nPeriod Hierarchy: ' + _.map(periodHRows, (a) => `${a.cif.WB_PERIOD_HIER_NAME} (${a.cif.WB_PERIOD_HIER_ID})`).join(","),
                description: "",
                subtitle: "",
                count: 0
            })
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }



    }
}
